import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { AUDIENCE_TYPE, TOOL_CATEGORY, CONTENT_TYPE_FILTER, REGISTRY_TYPE } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'registry-search-filter',
})

export default class RegistrySearchFilter extends Vue {

    // -------------------------------------------------------------------------
    // Properties

    /***
     * @property {Array} filterList Here we are using schema for the dropdown field
     * If we change anything from Object it will Affect entire filter
     */
    private filterList: any = {
        category: {
            name: 'Category',
            selectedItems: [],
            items: [],
            textField: 'title',
            valueField: 'id',
            action: this.fetchSubjectList,
        },
        subject: {
            name: 'Subject',
            selectedItems: [],
            items: [],
            textField: 'title',
            valueField: 'id',
            action: this.fetchGradesList,
        },
        grades: {
            name: 'Grades',
            selectedItems: [],
            items: [],
            textField: 'grade',
            valueField: 'id',
            multiSelect: true,
        },
        audience: {
            name: 'Audience',
            selectedItems: [],
            items: AUDIENCE_TYPE,
            textField: 'text',
            valueField: 'value',
        },
        toolCateogry: {
            name: 'Tool Categories',
            selectedItems: [],
            items: TOOL_CATEGORY,
            textField: 'text',
            valueField: 'value',
            multiSelect: true,
        },
    };

    @Prop({ default: {} })
    private selectedList: any;

    @Prop()
    private existingTerms!: string;

    @Prop()
    private registryType!: string;

    private searchTerms: string = '';

    private get filtersCount() {
        const selectedList = this.selectedList;
        return Object.values(selectedList).reduce((total, item: any) => total + item.length, 0);
    }

    // ---------------------------------------------------------------------------
    // Hooks

    private created() {
        if (this.registryType && this.registryType === REGISTRY_TYPE.contentRegistry) {
            this.$set(this.filterList, 'groupCode', {
                name: 'Content Type',
                selectedItems: [],
                key: 'groupCode',
                items: CONTENT_TYPE_FILTER,
                textField: 'text',
                valueField: 'value',
            });
            Object.keys(this.filterList).forEach((filterItem) => {
                this.selectedList[filterItem] = this.filterList[filterItem].selectedItems;
            });
        }
    }

    private mounted() {
        this.fetchCategoryList();
        this.parseFilterItems();
        this.searchTerms = this.existingTerms;
    }

    // -----------------------------------------------------------------------------
    // Actions

    private onSearch() {
        this.$emit('onSearch', this.searchTerms);
    }

    private onSelectFilter(fltKey: string, filterItem: any, selectedItem: any) {
        let selectedItems = this.filterList[fltKey].selectedItems;
        const isMultiSelect = filterItem.multiSelect;
        const valueField = filterItem.valueField;

        // Checking Selected values already added or push new key
        if (selectedItems.indexOf(selectedItem[valueField]) !== -1) {
            selectedItems = selectedItems.filter((item: string) => item !== selectedItem[valueField]);
        } else {
            selectedItems = [...new Set([...(isMultiSelect ? selectedItems : []), selectedItem[valueField]])];
        }

        // If it has any action to trigger
        if (filterItem.action) {
            filterItem.action(selectedItem[valueField]);
        }

        this.filterList[fltKey].selectedItems = selectedItems;
    }

    private onApplyFilter() {
        const filterDropdown = this.$refs.filterDropdown as any;
        const filterList = this.filterList;
        const selectedList: any = {};
        Object.keys(filterList).forEach((filterItem) => {
            selectedList[filterItem] = filterList[filterItem].selectedItems;
        });
        filterDropdown.hide(true);
        this.$emit('onApplyFilter', selectedList);
    }


    // ----------------------------------------------------------------------------------
    // Methods

    private fetchCategoryList() {
        taxonomyAPI.fetchTaxonomyClassifications().then((categories) => {
            this.filterList.category.items = categories;
        });
    }

    private fetchSubjectList(categoryId: string) {
        taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            const { subject } = this.filterList;
            subject.items = subjectList;
        });
    }

    private fetchGradesList(subjectId: string) {
        taxonomyAPI.fetchTaxonomyGrades(subjectId, 'GUT').then((gradesList: any) => {
            const { grades } = this.filterList;
            grades.items = gradesList;
        });
    }

    private parseFilterItems() {
        const selectedList = this.selectedList;
        Object.keys(selectedList).forEach((item) => {
            const filterObj = this.filterList[item];
            const filterItems = selectedList[item] || [];
            filterObj.selectedItems = filterItems;
            if (filterObj.action && filterItems.length) {
                filterItems.forEach((listItem: any) => {
                    filterObj.action(listItem);
                });
            }
        });
    }


}
